import { useEffect } from "react";
import { useAnalytics } from "../hooks/useAnalytics";

const Admin = () => {
    useAnalytics();


    useEffect(() => {
        setTimeout(() => {
            window.location.replace(process.env.REACT_APP_ADMIN_URL);
        }, 100);
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>Redirecting...</p>
        </div>
    );
};

export default Admin;
